import { TargetingDropdownSection } from '../../../shared/ReadOnlyTargetingDropdown/TargetingDropdownSection.tsx';
import { getOptionName } from '../../constants.ts';
import type { CommonItemPropsType } from '../../types.ts';
import { DefaultItems } from './DefaultItems.tsx';

export const LivestreamItem = ({
  type,
  onOpenDrawerClick,
  showDimensionChipLine,
  hideButtons,
  selectedParams,
  onChange,
  onRemove,
  readonly,
  dimensionChipLine,
  targetingParams,
  optionsCount,
  isDisabled,
  disabledReasonMessage,
}: CommonItemPropsType) => {
  return (
    <>
      <TargetingDropdownSection
        name={getOptionName(type)}
        hideButtons={hideButtons}
        isEmpty={!selectedParams.includes(type)}
        onOpenDrawerClick={onOpenDrawerClick}
        onRemove={onRemove}
        hasOptionsSelected={!!optionsCount && optionsCount > 0}
        isDisabled={isDisabled}
        disabledReasonMessage={disabledReasonMessage}
      >
        <DefaultItems
          targetingParams={targetingParams}
          type={type}
          readonly={readonly}
          onChange={onChange}
          disabledReasonMessage={disabledReasonMessage}
        />
      </TargetingDropdownSection>
      {showDimensionChipLine && dimensionChipLine(selectedParams.includes(type))}
    </>
  );
};
